var GlobalConstants = {
  goBoostPartnersBaseUrl: 'https://bots.goboost.io',
  matomoScriptUrl:'//hello.goboost.io/',
  ctmAccountId: '209678'
};
module.exports = GlobalConstants;